/* istanbul ignore file */
import { EMPLOYEE_CONTRACT_TYPES } from 'domain/shared/employee';
import { EnumField, FieldProps } from 'framework/ui/field';

const ContractTypeField = (props: FieldProps) => {
  return <EnumField {...props} options={EMPLOYEE_CONTRACT_TYPES} />;
};

export default ContractTypeField;
